import React, { useState, useEffect, useRef } from "react";
import { Avatar, Drawer, Input, Tabs, message, Select, Button } from "antd";
import CustomScrollbars from "util/CustomScrollbars";
import { createData, getData } from "util/API";
import WidgetHeader from "components/WidgetHeader/index";
import ChatUserList from "./ChatUserList";
import Conversation from "./Conversation";
import ContactList from "./ContactList/";
import IntlMessages from "util/IntlMessages";
import SearchBox from "components/SearchBox";
import CircularProgress from "../../../components/CircularProgress";
import "./chatbox.less";
import { useDispatch, useSelector } from "react-redux";
import {
  appendMessaageToCoversationData,
  getChatUsersListDataDjango,
  searchChatUsers,
  sendMessageToChatDjango,
  setChatUsers,
  setConversationData,
  setSelectedUser,
} from "../../../appRedux/actions/Chat";
import {
  fetchChatHistory,
  sendMessageToChat,
} from "../../../chatServices/XMPPservice";
import moment from "moment";
import { useXMPP } from "../../../providers/XMPPProvider";

const { TabPane } = Tabs;
const { Option } = Select;

async function getChatMessages(jid) {
  const messages = await fetchChatHistory(jid);

  return messages || [];
}

export const transformInternalChat = (data) => {
  return data.map((item) => ({
    status: "away",
    last_message: item.lastMessage,
    unread_message: "",
    last_message_time: item.timestamp,
    unread_message_count: item.unreadCount,
    read_status: false,
    receiver_name: item.name,
    receiver_uuid: item.userId,
    source: "internal",
  }));
};

const Chat = ({}) => {
  const dispatch = useDispatch();
  const {
    sessionAddress,
    rosterList,
    conversationData,
    selectedUser,
    chatUsers,
  } = useSelector((state) => state.chat);
  const { xmpp, initXMPP } = useXMPP();
  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [userNotFound, setUserNotFound] = useState("Chat not found");
  const [drawerState, setDrawerState] = useState(false);
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [userState, setUserState] = useState(1);
  const [searchChatUser, setSearchChatUser] = useState("");
  const [contactList, setContactList] = useState([]);
  const [userMessage, setUserMessage] = useState("");
  const [partnersList, setPartnersList] = useState([]);
  const [showChatOptions, setShowChatOptions] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [selectedMatrixUser, setSelectedMatrixUser] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [filteredChatUsers, setFilteredChatUsers] = useState([]);
  const [filteredContactList, setFilteredContactList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [isPhoneNumberDisabled, setIsPhoneNumberDisabled] = useState(false);
  const [isMatrixUserDisabled, setIsMatrixUserDisabled] = useState(false);
  const [whatsappChatUsers, setWhatsappChatUsers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);

  const user_name = localStorage.getItem("user_full_name");
  const user_email = localStorage.getItem("user_email_id");
  const user_uuid = localStorage.getItem("user_uuid");

  useEffect(() => {
    let searchD = setTimeout(() => {
      if (searchVal) {
        fetchSearchChat(searchVal);
      } else {
        setPartnersList([]);
      }
    }, 1000);

    return () => clearTimeout(searchD);
  }, [searchVal]);

  const fetchSearchChat = (searching) => {
    setSearchLoading(true);
    dispatch(
      searchChatUsers(
        searching,
        (users) => {
          const uniqueUser = Array.from(
            new Map(users.map((user) => [user.uuid, user])).values()
          );

          setPartnersList(
            uniqueUser.map((user, usrIdx) => (
              <Option key={user.uuid} ref={user} value={JSON.stringify(user)}>
                {user.full_name}
              </Option>
            ))
          );
        },
        () => {
          console.log("No Users Found");
          setPartnersList([]);
        },
        () => {
          setSearchLoading(false);
        }
      )
    );
  };

  // Matrix Users List
  const fetchChatList = () => {
    let isMounted = true;
    dispatch(
      getChatUsersListDataDjango((res) => {
        if (isMounted) {
          const transformedData = transformInternalChat(res?.data);
          dispatch(setChatUsers(transformedData));
          setUserNotFound("");
        }
      }),
      (err) => {
        if (isMounted) {
          dispatch(setChatUsers([]));
          setUserNotFound(err?.message || "Chat not found");
        }
      }
    );
    return () => {
      isMounted = false;
    };
  };

  const transformWhatsappData = (data) => {
    return data.map((item) => ({
      id: item.session_id,
      customer_id: item.session_id,
      channel_name: item.partner_chat_id,
      status: "away",
      last_message: item.last_message?.messagetext || "",
      unread_message: "",
      last_message_time: item.last_message_time,
      unread_message_count: item.unread_count,
      read_status: false,
      receiver_name: item.receiver_name,
      receiver_uuid: item.receiver_id,
      customer_phone: item.receiver_phone,
      source: "whatsapp",
    }));
  };

  // Whatsapp Users List
  const fetchWhatsappChats = () => {
    let endpoint = "/management/get-whatsapp-users-list/";

    getData(endpoint)
      .then((res) => {
        if (
          res.status === 200 &&
          Array.isArray(res.data.chats) &&
          res.data.chats.length > 0
        ) {
          const transformedData = transformWhatsappData(res.data.chats);
          setWhatsappChatUsers(res.data.chats);
          const mergedUsers = [...chatUsers];
          transformedData.forEach((newUser) => {
            const exists = mergedUsers.some((user) => user.id === newUser.id);
            if (!exists) {
              mergedUsers.push(newUser);
            }
          });

          mergedUsers.sort((a, b) => {
            const timeA = new Date(a.last_message_time).getTime() || 0;
            const timeB = new Date(b.last_message_time).getTime() || 0;
            return timeB - timeA;
          });
          dispatch(setChatUsers(mergedUsers));
        } else if (res.status === 200 && res.data.message) {
          setWhatsappChatUsers([]);
        } else {
          setWhatsappChatUsers([]);
        }
      })
      .catch((error) => {
        console.error(error);
        setWhatsappChatUsers([]);
      });
  };

  const fetchWhatsappConversation = (sessionId) => {
    const endpoint = `/management/get-whatsapp-chats/?session_id=${sessionId}`;
    getData(endpoint)
      .then((res) => {
        if (res.data && res.data) {
          dispatch(setConversationData(res.data));
        }
      })
      .catch((error) => {
        message.error("Failed to fetch whatsapp conversation data");
      });
  };

  const handleScroll = () => {
    const container = chatContainerRef.current;
    if (container) {
      const isBottom =
        Math.ceil(container.scrollTop + container.clientHeight) >=
        container.scrollHeight;
      setIsAtBottom(isBottom);
    }
  };

  useEffect(() => {
    if (selectedUser && selectedUser.receiver_uuid) {
      if (selectedUser.customer_phone) {
        fetchWhatsappConversation(selectedUser.id);
        setInterval(() => {
          fetchWhatsappConversation(selectedUser.id);
        }, 600000);
      } else {
        getChatMessages(
          selectedUser.receiver_uuid + "@" + sessionAddress?._domain
        ).then((msg) => {
          dispatch(setConversationData(msg));
        });
      }
    }
  }, [selectedUser]);

  useEffect(() => {
    const scrollToBottom = () => {
      if (chatEndRef.current) {
        chatEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    };

    if (isAtBottom) {
      scrollToBottom();
    } else {
      console.log("User is not at the bottom. Scroll prevented.");
    }
  }, [conversationData, isAtBottom]);

  useEffect(() => {
    const scrollToBottomOnInit = () => {
      if (chatEndRef.current) {
        chatEndRef.current.scrollIntoView({ behavior: "auto", block: "end" });
      }
    };

    if (selectedUser && conversationData.length > 0) {
      scrollToBottomOnInit();
    }
  }, [selectedUser, conversationData]);

  useEffect(() => {
    setTimeout(() => {
      fetchChatList();
      fetchWhatsappChats();
    }, 1000);
  }, []);

  const addWhatsappNumber = (value) => {
    const endpoint = `/management/add-number/`;
    const data = {
      action: "whatsapp",
      to: value,
    };

    createData(endpoint, data)
      .then((res) => {
        // console.log("Add Number", res);
        if (res.status === 200) {
          const customerPhone = res.data.data.receiver_phone;
          const formattedPhone = customerPhone.startsWith("91")
            ? customerPhone.slice(2)
            : customerPhone;
          const user = {
            id: res.data.data.session_id || "",
            channel_name: res.data.data.partner_chat_id || "",
            status: "away",
            last_message: "",
            unread_message: "",
            last_message_time: "",
            unread_message_count: "",
            read_status: false,
            receiver_name: res.data.data.receiver_name || formattedPhone || "",
            receiver_uuid: res.data.data.receiver_id || "",
            customer_phone: formattedPhone || "",
            source: "whatsapp",
          };

          onSelectUser(user);
          const isUserAlreadyPresent = chatUsers.some(
            (chatUser) => chatUser.customer_phone === user.customer_phone
          );
          let prevUsers = [...chatUsers];
          if (!isUserAlreadyPresent) {
            prevUsers = [...chatUsers, user];
          }
          dispatch(setChatUsers(prevUsers));
        } else {
          message.error(res.data.message);
        }
      })
      .catch(() => {
        // message.error("Error adding whatsapp number!");
      });
  };

  const onChatPost = async (selectedUser) => {
    let endpoint = "";
    let data = "";

    if (selectedUser.customer_phone) {
      endpoint = `/management/send-whatsapp-message/`;
      data = {
        customer_id: selectedUser.receiver_uuid,
        message: userMessage,
      };

      createData(endpoint, data)
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            // Handle success
          } else {
            message.error(res.data.message);
          }
        })
        .catch(() => {
          message.error("Error posting chat!");
        });
    } else {
      sendMessage();
      // endpoint = `/management/internal-messages/`;
      // data = {
      //   message: userMessage,
      //   sender_id: user_uuid,
      //   sender_name: user_name,
      //   reciever_name: selectedUser.receiver_name,
      //   receiver_id: selectedUser.receiver_uuid,
      // };
    }
  };

  const adjustTextareaHeight = (e) => {
    const textarea = e.target;
    textarea.style.height = "auto";
    textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
  };

  const sendMessage = () => {
    if (!navigator.onLine) {
      message.error(
        "Network Unavailable, Please check your internet connection."
      );
      return;
    }
    const timestamp = new Date();
    const fallbackTimestamp = new Date().toISOString();
    sendMessageToChat(
      userMessage?.trim(),
      selectedUser?.receiver_uuid + "@" + sessionAddress?._domain,
      async () => {
        dispatch(
          appendMessaageToCoversationData({
            body: userMessage,
            from: user_uuid,
            isRead: true,
            timestamp: fallbackTimestamp,
            to: selectedUser?.receiver_uuid,
            messageTimeStamp: moment(fallbackTimestamp).valueOf(),
            formattedDate: moment(fallbackTimestamp).format("MMM DD, YYYY"),
            formattedTime: moment(fallbackTimestamp).format("hh:mm a"),
            type: "sent",
            content: userMessage,
            timestamp: timestamp,
            is_read: false,
            sender: user_uuid,
            receiver: selectedUser.receiver_uuid,
          })
        );
        dispatch(
          sendMessageToChatDjango({
            recipientUUID: selectedUser?.receiver_uuid,
            receiverName: selectedUser?.receiver_name,
            messageText: userMessage?.trim(),
            sCall: () => {},
          })
        );
      }
    );
  };

  const handleMatrixUserChange = (value) => {
    if (value) {
      setSelectedMatrixUser(JSON.parse(value));
      setPhoneNumber("");
      setIsPhoneNumberDisabled(true);
    } else {
      setSelectedMatrixUser(null);
      setPhoneNumber("");
      setIsPhoneNumberDisabled(false);
    }
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;

    if (/^\d{0,10}$/.test(value)) {
      setPhoneNumber(value);

      if (value) {
        setSelectedMatrixUser(null);
        setIsMatrixUserDisabled(true);
      } else {
        setIsMatrixUserDisabled(false);
      }
    }
  };

  const handleStartChat = () => {
    if (selectedMatrixUser !== null) {
      const user = {
        id: "",
        channel_name: "",
        status: "away",
        last_message: "",
        unread_message: "",
        last_message_time: "",
        unread_message_count: "",
        read_status: false,
        receiver_name: selectedMatrixUser?.full_name || "",
        receiver_uuid: selectedMatrixUser?.uuid || "",
      };

      const existingUserIndex = chatUsers.findIndex(
        (chatUser) => chatUser.receiver_uuid === user.receiver_uuid
      );

      if (existingUserIndex !== -1) {
        const updatedMessages = [...chatUsers];
        updatedMessages[existingUserIndex] = {
          ...updatedMessages[existingUserIndex],
          ...user,
        };

        onSelectUser(updatedMessages[existingUserIndex]);
      } else {
        onSelectUser(user);
      }
      const isUserAlreadyPresent = chatUsers.some(
        (chatUser) => chatUser.receiver_uuid === user.receiver_uuid
      );
      let prevUsers = [...chatUsers];
      if (!isUserAlreadyPresent) {
        prevUsers = [...chatUsers, user];
      }
      dispatch(setChatUsers(prevUsers));
    }
    const response = {
      message: "This Whatsapp Number is not linked with any Partner",
      status: "failed",
    };

    if (response.status === "failed" && response.message) {
      setErrorMessage(response.message);
    } else {
      setErrorMessage("");
    }

    if (phoneNumber !== "") {
      addWhatsappNumber(phoneNumber);
    }
  };

  const onSelectUser = (user) => {
    setLoader(true);
    setSelectedSectionId(user.id);
    dispatch(setSelectedUser(user));

    const updatedUsers = chatUsers.map((u) =>
      u.id === user.id ? { ...u, unread_message: 0, read_status: "read" } : u
    );
    dispatch(setChatUsers(updatedUsers));

    const selectedConversation = conversationData.map((data) => {
      if (data.id === user.id) {
        return { ...data, read_status: "read" };
      }
      return data;
    });

    setTimeout(() => {
      setLoader(false);
    }, 1500);
  };

  const submitComment = () => {
    if (!userMessage.trim()) return;

    setUserMessage("");
    onChatPost(selectedUser);
  };

  const updateMessageValue = (e) => {
    setUserMessage(e.target.value);
  };

  useEffect(() => {
    setFilteredChatUsers(chatUsers);
    setFilteredContactList(contactList);
  }, [chatUsers, contactList]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchChatUser("");
    setFilteredChatUsers(chatUsers);
    setFilteredContactList(contactList);
  };

  useEffect(() => {
    let filterD = setTimeout(() => {
      if (activeTab === "1") {
        if (!searchChatUser) {
          if (chatUsers.length > 0) {
            setFilteredChatUsers(chatUsers);
          }
        } else {
          if (chatUsers.length > 0) {
            setFilteredChatUsers(
              chatUsers.filter((user) =>
                user?.receiver_name
                  ?.toLowerCase()
                  .includes(searchChatUser.toLowerCase())
              )
            );
          }
        }
      } else {
        setFilteredContactList(
          contactList.filter((user) =>
            searchChatUser === ""
              ? true
              : user?.receiver_name
                  ?.toLowerCase()
                  .includes(searchChatUser.toLowerCase())
          )
        );
      }
    }, 1500);

    return () => clearTimeout(filterD);
  }, [searchChatUser]);

  const updateSearchChatUser = (e) => {
    setSearchChatUser(e.target.value);
  };

  const Communication = () => {
    return (
      <div className="gx-chat-main">
        <div className="gx-chat-main-header">
          <span className="gx-d-block gx-d-lg-none gx-chat-btn">
            <i
              className="gx-icon-btn icon icon-chat"
              onClick={() => setDrawerState(!drawerState)}
            />
          </span>
          <div className="gx-chat-main-header-info">
            <div className="gx-chat-avatar gx-mr-2">
              <div className="gx-status-pos">
                <Avatar
                  src={require("assets/images/avatar/user.jpg")}
                  className="gx-rounded-circle gx-size-60"
                  alt={selectedUser?.receiver_name}
                />
                <span className={`gx-status gx-${selectedUser?.status}`} />
              </div>
            </div>
            <div className="gx-chat-contact-name">
              {selectedUser?.receiver_name}
              <span
                className={`gx-status gx-${
                  selectedUser?.status?.toLowerCase() || "offline"
                }`}
                style={{
                  display: "block",
                  fontSize: 12,
                  fontWeight: "normal",
                  textTransform: "uppercase",
                  color:
                    selectedUser?.status === "online"
                      ? "#4caf50"
                      : selectedUser?.status === "away"
                      ? "#ffc107"
                      : "#8c8c8c",
                }}
              >
                {selectedUser?.status || "Offline"}
              </span>
            </div>
          </div>
        </div>

        <CustomScrollbars
          className="gx-chat-list-scroll"
          ref={chatContainerRef}
          onScroll={handleScroll}
        >
          <Conversation
            conversationHistory={conversationData}
            selectedUser={selectedUser}
          />
          <div ref={chatEndRef} />
        </CustomScrollbars>

        <div className="gx-chat-main-footer">
          <div
            className="gx-flex-row gx-align-items-center"
            style={{ maxHeight: 51 }}
          >
            <div className="gx-col">
              <div className="gx-form-group">
                <textarea
                  id="required"
                  className="ant-input gx-chat-textarea"
                  onChange={(e) => {
                    setUserMessage(e.target.value);
                    adjustTextareaHeight(e);
                    e.target.focus();
                  }}
                  value={userMessage}
                  placeholder="Type and hit enter to send message"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      submitComment();
                    }
                  }}
                />
              </div>
            </div>
            <i
              className="gx-icon-btn icon icon-sent"
              onClick={() => submitComment()}
              style={{
                opacity: !userMessage.trim() ? 0.5 : 1,
                cursor: !userMessage.trim() ? "not-allowed" : "pointer",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const AppUsersInfo = () => {
    return (
      <div className="gx-chat-sidenav-main">
        <div className="gx-bg-grey-light gx-chat-sidenav-header">
          <div className="gx-chat-user-hd gx-mb-0">
            <i
              className="gx-icon-btn icon icon-arrow-left"
              onClick={() => setUserState(1)}
            />
          </div>
          <div className="gx-chat-user gx-chat-user-center">
            <div className="gx-chat-avatar gx-mx-auto">
              <Avatar
                src={require("assets/images/avatar/user.jpg")}
                className="gx-size-60"
                alt="John Doe"
              />
            </div>
            <div className="gx-user-name h4 gx-my-2">Robert Johnson</div>
          </div>
        </div>
        <div className="gx-chat-sidenav-content">
          <CustomScrollbars className="gx-chat-sidenav-scroll">
            <div className="gx-p-4">
              <form>
                <div className="gx-form-group gx-mt-4">
                  <label>Mood</label>
                  <Input
                    fullWidth
                    id="exampleTextarea"
                    multiline
                    rows={3}
                    onChange={updateMessageValue}
                    defaultValue="it's a status....not your diary..."
                    placeholder="Status"
                    margin="none"
                  />
                </div>
              </form>
            </div>
          </CustomScrollbars>
        </div>
      </div>
    );
  };

  const ChatUsers = () => {
    return (
      <div className="gx-chat-sidenav-main">
        <div className="gx-chat-sidenav-header">
          {!xmpp && (
            <div
              style={{
                alignItems: "stretch",
                justifyContent: "center",
                display: "flex",
                marginBottom: "10px",
              }}
            >
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() => {
                  initXMPP();
                }}
              >
                Connect to Chat
              </Button>
            </div>
          )}
          <div className="gx-chat-user-hd">
            {/* <div className="gx-chat-avatar gx-mr-3" onClick={() => setUserState(2)}> */}
            <div className="gx-chat-avatar gx-mr-3">
              <div className="gx-status-pos">
                <Avatar
                  id="avatar-button"
                  src={require("assets/images/avatar/user.jpg")}
                  className="gx-size-50"
                  alt=""
                />
                <span className="gx-status gx-online" />
              </div>
            </div>
            <div className="gx-module-user-info gx-flex-column gx-justify-content-center">
              <div className="gx-module-title">
                <h5 className="gx-mb-0">{user_name}</h5>
              </div>
              <div className="gx-module-user-detail">
                <span className="gx-text-grey gx-link">{user_email}</span>
              </div>
            </div>
          </div>

          <div className="gx-chat-search-wrapper">
            <SearchBox
              styleName="gx-chat-search-bar gx-lt-icon-search-bar-lg"
              placeholder="Search or start new chat"
              onChange={updateSearchChatUser}
              value={searchChatUser}
              // autoFocus={false}
            />
          </div>
        </div>

        <div className="gx-chat-sidenav-content">
          <Tabs
            className="gx-tabs-half"
            activeKey={activeTab}
            onChange={handleTabChange}
          >
            <TabPane
              label={<IntlMessages id="chat.chatUser" />}
              tab={<IntlMessages id="chat.chatUser" />}
              key="1"
            >
              <CustomScrollbars className="gx-chat-sidenav-scroll-tab-1">
                {filteredChatUsers.length === 0 ? (
                  <div className="gx-p-5">{userNotFound}</div>
                ) : (
                  <ChatUserList
                    selectedSectionId={selectedSectionId}
                    onSelectUser={onSelectUser}
                    chatUsers={filteredChatUsers.map((user) => ({
                      ...user,
                      unread_message_count: user.read_status
                        ? 0
                        : user.unread_message_count,
                    }))}
                  />
                )}
              </CustomScrollbars>
            </TabPane>
            {/* Hidden Contacts Tab */}
            {activeTab === "2" && (
              <TabPane
                tab={<IntlMessages id="chat.contacts" />}
                key="2"
                forceRender={false} // Don't render the tab when not active
              >
                <CustomScrollbars className="gx-chat-sidenav-scroll-tab-2">
                  {filteredContactList.length === 0 ? (
                    <div className="gx-p-5">{userNotFound}</div>
                  ) : (
                    <ContactList
                      contactList={filteredContactList}
                      selectedSectionId={selectedSectionId}
                      onSelectUser={onSelectUser}
                    />
                  )}
                </CustomScrollbars>
              </TabPane>
            )}
          </Tabs>
        </div>
      </div>
    );
  };

  const showCommunication = () => {
    return (
      <div className="gx-chat-box">
        {selectedUser === null ? (
          <div className="gx-comment-box">
            {!showChatOptions ? (
              <>
                <div
                  onClick={() => setShowChatOptions(true)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="gx-fs-80">
                    <i className="icon icon-chat gx-text-muted" />
                  </div>
                  <h1 className="gx-text-muted">Select User to start Chat</h1>
                </div>
              </>
            ) : (
              <>
                <h1 className="gx-text-muted">Select User to start Chat</h1>

                <div
                  style={{ margin: "20px 0", width: "100%", maxWidth: "400px" }}
                >
                  <WidgetHeader
                    styleName="gx-flex-row"
                    title="Message Matrix users:"
                  />
                  <Select
                    loading={searchLoading}
                    id="internalUserSelect"
                    placeholder="Select a Matrix user"
                    style={{ width: "100%", marginTop: "5px" }}
                    showSearch
                    optionFilterProp="children"
                    onSearch={(val) => setSearchVal(val)}
                    onChange={handleMatrixUserChange}
                    disabled={isMatrixUserDisabled}
                    filterOption={false}
                    notFoundContent="No users found"
                    allowClear
                  >
                    {partnersList}
                  </Select>
                </div>

                <div
                  style={{ margin: "20px 0", width: "100%", maxWidth: "400px" }}
                >
                  <WidgetHeader
                    styleName="gx-flex-row"
                    title="WhatsApp Phone Number:"
                  />
                  <Input
                    id="whatsappNumber"
                    placeholder="Enter WhatsApp number"
                    type="tel"
                    style={{ marginTop: "5px" }}
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    disabled={isPhoneNumberDisabled}
                  />
                  {errorMessage && (
                    <div
                      style={{ marginTop: "10px", color: "red", fontSize: 14 }}
                    >
                      {errorMessage}
                    </div>
                  )}
                </div>

                <div style={{ marginTop: "20px", textAlign: "center" }}>
                  <Button type="primary" onClick={handleStartChat}>
                    Start Chat
                  </Button>
                </div>
              </>
            )}
          </div>
        ) : (
          Communication()
        )}
      </div>
    );
  };

  return (
    <div className="gx-main-content">
      <div className="gx-app-module gx-chat-module">
        <div className="gx-chat-module-box">
          <div className="gx-d-block gx-d-lg-none">
            <Drawer
              placement="left"
              closable={false}
              visible={drawerState}
              onClose={() => setDrawerState(!drawerState)}
            >
              {userState === 1 ? <ChatUsers /> : <AppUsersInfo />}
            </Drawer>
          </div>
          <div className="gx-chat-sidenav gx-d-none gx-d-lg-flex">
            {userState === 1 ? <ChatUsers /> : <AppUsersInfo />}
          </div>
          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : (
            showCommunication()
          )}
        </div>
      </div>
    </div>
  );
};

export default Chat;
